import React from "react";
import './App.css';
import "bootstrap/dist/css/bootstrap.min.css";
import { Navbar } from "react-bootstrap";
import Home from "./pages/Home";
import Expire from "./pages/Expired";
import Payment from "./pages/Payment2";
import Contract from "./pages/Contract";
import ContractView from "./pages/ContractView";
import NewContract from "./pages/NewContract";
import NoRoute from "./pages/NoRoute";
import Logo from './images/pinstack-header.png';
import { Routes, Route } from "react-router-dom";

function App() {
  return (
    <div className="App" style={{ backgroundColor: '#006e96' }}>
      <Navbar className="justify-content-center" bg="dark" variant="dark">
        <Navbar.Brand>
          <img
            alt=""
            src={Logo}
            id="homePhoto"
            className="d-inline-block align-top"
            style={{ cursor: "pointer" }}
          />
        </Navbar.Brand>
      </Navbar>
      <Routes>
        <Route path="/" element={<NoRoute />} />
        <Route path="/:id" element={<Home />} />
        <Route path="/:id/contract" element={<NewContract />} />
        <Route path="/:id/contractview" element={<ContractView />} />
     
        <Route path="/:id/payment" element={<Payment />} />
        <Route path="/:id/expired" element={<Expire />} />
      </Routes>

    </div>
  );
}

export default App;